export default {
	SET_MENU: 'SET_MENU',
	SET_MENU_CATEGORIES: 'SET_MENU_CATEGORIES',
	SET_SELECTED_PRODUCT: 'SET_SELECTED_PRODUCT',
	SET_PRODUCT_ADDITIONALS: 'SET_PRODUCT_ADDITIONALS',
	SET_SEARCH_TERM: 'SET_SEARCH_TERM',
	REMOVE_SELECTED_PRODUCT_ADDITIONAL: 'REMOVE_SELECTED_PRODUCT_ADDITIONAL'
}
